import { FC, useEffect, useState } from 'react';
import { ExtendedGridColDef } from '@/types/ExtendedGridColDef';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { Grid, TextField, Button, Box, Tabs, Tab, CircularProgress } from '@mui/material';
import { SCUIContent } from '../../atomic/organisms';
import { SCUICustomDataGrid } from '../../atomic/molecules';
import { SCUIButton } from '../../atomic/atoms';
import Swal from 'sweetalert2';
import MobileClientTranslationsQuery from '../../services/query/mobileAppClientTranslations/MobileAppClientTranslations.services';
import MobilePanelClientTranslationsCommand from '../../services/command/mobilepanelclienttranslation/MobilePanelClientTranslationsCommand.services';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { SCUIMPClientTranslationsDialog } from '../../atomic/molecules/SCUIMPClientTranslationsDialog/SCUIMPClientTranslationsDialog';
import SCUIDropdown from '../../atomic/atoms/SCUIDropdown/SCUIDropdown';
import { format } from 'date-fns';
import clsx from 'clsx';
import { BulkUploadTab } from './components/BulkUploadTab';
import { MPCT, mpctCls } from './mpClientTranslations.classes';

export const MpClientTranslations: FC<any> = () => {
    const { t } = useTranslation();
    const [refresh, setRefresh] = useState(false);
    const [searchedMpClientTranslationsList, setSearchedMobilePanelClientTranslationsList] = useState<any>();
    const [openEditModal, setOpenEditModal] = useState(false);
    const onModalEditClose = () => setOpenEditModal(false);
    const refreshFunc = () => setRefresh((prevRefreshing) => !prevRefreshing);
    const onModalEditOpen = () => setOpenEditModal(true);
    const [searchedMpClientTranslationsName, setSearchedMpClientTranslations] = useState('');
    const [mobilePanelClientTranslations, setMobilePanelClientTranslations] = useState([]);
    const [mpClientTranslations, setMpClientTranslations] = useState<any>();
    const countryStore: any = useSelector((state: any) => state?.country);
    const countryState = countryStore?.country;
    const [cultureList, setCultureList] = useState<any>();
    const [selectedCulture, setSelectedCulture] = useState('');
    const [loading, setLoading] = useState(false);
    const [activeTab, setActiveTab] = useState(0);

    const getSupportedCulturesByCountryId = () => {
        setLoading(true);
        let req = { countryId: countryStore.country };
        MobileClientTranslationsQuery.GetSupportedCulturesByCountryId(req)
            .then((res: any) => {
                if (res) {
                    console.info(res);
                    let parsedata = res.model.data.map((item: any) => {
                        return {
                            key: 'culture',
                            id: item.cultureId,
                            value: item.cultureCode,
                            name: item.cultureCode,
                        };
                    });

                    setCultureList(parsedata);
                    setSelectedCulture(parsedata[0]?.name);
                }
            })
            .catch((error: any) => {
                console.log('Hata :>> ', error);
            })
            .finally(() => {
                setLoading(false); /*getMobilePanelClientTranslations(selectedCulture);*/
            });
    };

    const getMobilePanelClientTranslations = (lastSelectedCulture: any) => {
        setLoading(true);
        let req = { countryId: countryStore.country, culture: lastSelectedCulture };
        MobileClientTranslationsQuery.ListMobileAppClientTranslations(req)
            .then((res: any) => {
                if (res) {
                    console.info(res);
                    let parseData = res.model.data.map((item: any) => {
                        return {
                            id: item.clientKeyId || '-',
                            parameter_key: item.clientKey || ' ',
                            parameter_value: item.clientKeyValue || ' ',
                            updated_by: item.updatedBy || ' ',
                            updated_date: item.updateDate || ' ',
                        };
                    });
                    setMobilePanelClientTranslations(parseData);
                    setSearchedMobilePanelClientTranslationsList(parseData);
                }
            })
            .catch((error: any) => {
                console.log('Hata :>> ', error);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    useEffect(() => {
        getSupportedCulturesByCountryId();
    }, [countryStore.country]);

    useEffect(() => {
        if (selectedCulture) {
            getMobilePanelClientTranslations(selectedCulture);
        }
    }, [refresh, selectedCulture]);

    const requestSearchMpClientTranslations = (searchedVal: any) => {
        setSearchedMpClientTranslations(searchedVal.target.value);
        let filteredRoles = searchedMpClientTranslationsList.filter(
            (o: any) => o.parameter_key.toLowerCase().indexOf(searchedVal.target.value.toLowerCase()) !== -1
        );
        setMobilePanelClientTranslations(filteredRoles);
    };
    const deleteMobilePanelClientTranslation = async (params: any) => {
        const result = await Swal.fire({
            text: t('mobilePanel.deleteConfig'),
            cancelButtonText: t('general.cancel'),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: t('general.delete'),
        });

        if (!result.isConfirmed) {
            return;
        }

        try {
            await MobilePanelClientTranslationsCommand.PostRemoveMobilePanelClientTranslation(params);
            Swal.fire('Silindi!', ' ', 'success');
            setRefresh((prevRefreshing) => !prevRefreshing);
        } catch (error: any) {
            console.log('Hata :>> ', error);
        }
    };

    const formatDate = (dateString: string): string => {
        const date = new Date(dateString);
        return format(date, 'dd-MM-yyyy / HH:mm:ss');
    };
    const handleSelectChange = (e: any) => {
        setSelectedCulture(e);
        // getMobilePanelClientTranslations(e);
    };

    const columns: ExtendedGridColDef[] = [
        { field: 'id', headerName: 'ID', width: 90, flex: 1, hide: true },
        {
            field: 'parameter_key',
            headerName: 'Key',
            width: 150,
            flex: 1,
        },
        {
            field: 'parameter_value',
            headerName: 'Value',
            width: 160,
            flex: 1,
            cellClassName: (params: any) => {
                if (params.row.parameter_value == null || params.row.parameter_value.trim() == '')
                    return clsx('super-app negative');
                return clsx('super-app');
            },
        },
        {
            field: 'updated_by',
            headerName: 'User Name',
            width: 160,
            flex: 1,
        },
        {
            field: 'updated_date',
            headerName: 'Last Update Time',
            width: 160,
            flex: 1,
            renderCell: (params: any) => <>{params.value ? formatDate(params.value) || '-' : '-'}</>,
        },
        {
            field: 'edit',
            headerName: t('general.edit'),
            width: 160,
            headerAlign: 'center',
            flex: 1,
            align: 'center',
            renderCell: (params) => {
                const onclick = () => {
                    setMpClientTranslations(params.row);
                    onModalEditOpen();
                };

                return (
                    <div className={MPCT.datagridEditCell}>
                        <Button className={MPCT.inputButtonRowEdit} onClick={onclick}>
                            <EditIcon />
                        </Button>
                    </div>
                );
            },
        },

        {
            field: 'delete',
            headerName: t('general.delete'),
            width: 160,
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params) => {
                const onclick = () => {
                    let request = {
                        ClientTranslationKeyId: params.id,
                        CountryId: countryState.country,
                    };
                    deleteMobilePanelClientTranslation(request);
                };
                return (
                    <div className={MPCT.datagridDeleteCell}>
                        <Button className={MPCT.inputButtonRowDelete} onClick={onclick}>
                            <DeleteIcon />
                        </Button>
                    </div>
                );
            },
        },
    ];
    const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
        setActiveTab(newValue);
        // Refresh the list when switching back to List tab (tab 0)
        if (newValue === 0) {
            refreshFunc();
        }
    };

    if (loading) {
        return (
            <Grid className={MPCT.loadingGate} container style={{ height: '100%' }} alignItems="center" justifyContent="center">
                <div
                    className={MPCT.loadingSpinnerWrap}
                    style={{
                        textAlign: 'center',
                        position: 'relative',
                        pointerEvents: 'none',
                    }}
                >
                    <CircularProgress size={80} />
                </div>
            </Grid>
        );
    }
    return (
        <SCUIContent>
            <SCUIMPClientTranslationsDialog
                selectedRow={mpClientTranslations}
                open={openEditModal}
                onClose={onModalEditClose}
                refresh={refreshFunc}
                selectedCulture={selectedCulture}
            />
            <Grid className={MPCT.page} container direction="row" spacing={2} alignItems="center">
                <Grid
                    size={{
                        lg: 8,
                        md: 6,
                        xs: 12,
                    }}
                >
                    <Box className={MPCT.titleSection} sx={{ marginLeft: '16px' }}>
                        <h1 className={mpctCls('headtxt', MPCT.pageTitle)}>{t('mobilePanel.mobilePanelClientTranslations')}</h1>
                    </Box>
                </Grid>
                <Grid
                    size={{
                        lg: 4,
                        md: 6,
                        xs: 12,
                    }}
                >
                    <Box
                        className={MPCT.actionsSection}
                        sx={{
                            display: 'flex',
                            justifyContent: 'flex-end',
                            alignItems: 'center',
                            gap: '24px',
                        }}
                    >
                        <Box
                            className={MPCT.actionsInner}
                            sx={{
                                position: 'relative',
                                height: '40px',
                                display: 'flex',
                                flexDirection: 'row',
                                alignItems: 'center',
                                marginBottom: '16px',
                                marginRight: '24px',
                            }}
                        >
                            {cultureList && cultureList.length > 0 && (
                                <Box className={MPCT.cultureDropdownWrap}>
                                    <SCUIDropdown
                                        dataList={cultureList}
                                        labelText={t('mobilePanel.selectCulture')}
                                        selectedValue={selectedCulture}
                                        setSelectedValue={(e: any) => handleSelectChange(e)}
                                    ></SCUIDropdown>
                                </Box>
                            )}
                            {activeTab === 0 && (
                                <Box className={MPCT.addButtonWrap} sx={{ flex: '0 0 auto', marginLeft: '16px' }}>
                                    <SCUIButton
                                        className={MPCT.inputButtonAddTranslation}
                                        text={t('mobilePanel.addTranslation')}
                                        type="primary"
                                        sizeType="fixed"
                                        size={'m'}
                                        onClick={() => {
                                            setMpClientTranslations([]);
                                            onModalEditOpen();
                                        }}
                                    />
                                </Box>
                            )}
                        </Box>
                    </Box>
                </Grid>

                <Grid
                    size={{
                        xs: 12,
                    }}
                >
                    <Box className={MPCT.tabsWrap} sx={{ borderBottom: 1, borderColor: 'divider' }}>
                        <Tabs className={MPCT.tabsRoot} value={activeTab} onChange={handleTabChange} aria-label="translation tabs">
                            <Tab className={MPCT.tabTranslationList} label={t('mobilePanel.translationList')} />
                            <Tab className={MPCT.tabBulkUpload} label={t('mobilePanel.bulkUpload')} />
                        </Tabs>
                    </Box>
                </Grid>

                {activeTab === 0 && (
                    <>
                        <Grid
                            size={{
                                xs: 12,
                            }}
                        >
                            <Box className={MPCT.listTabSearchWrap} sx={{ display: 'flex', alignItems: 'center', height: '100%' }}>
                                <TextField
                                    className={MPCT.inputTextSearchKey}
                                    label="Key"
                                    value={searchedMpClientTranslationsName}
                                    onChange={(e) => requestSearchMpClientTranslations(e)}
                                    fullWidth
                                    slotProps={{
                                        inputLabel: {
                                            style: { marginTop: '-4px' },
                                        },
                                    }}
                                />
                            </Box>
                        </Grid>

                        <Grid
                            size={{
                                sm: 12,
                                md: 12,
                                lg: 12,
                                xl: 12,
                            }}
                        >
                            <Box
                                className={MPCT.listTabGridWrap}
                                sx={{
                                    height: 300,
                                    width: '100%',
                                    '& .super-app.negative': {
                                        backgroundColor: 'rgba(255, 54, 6, 0.49)',
                                        color: '#1a3e72',
                                        fontWeight: '600',
                                    },
                                }}
                            >
                                <SCUICustomDataGrid
                                    rows={mobilePanelClientTranslations}
                                    columns={columns}
                                    initialState={{
                                        sorting: {
                                            sortModel: [
                                                {
                                                    field: 'id',
                                                    sort: 'asc',
                                                },
                                            ],
                                        },
                                    }}
                                />
                            </Box>
                        </Grid>
                    </>
                )}

                {activeTab === 1 && (
                    <Grid
                        container
                        size={{
                            xs: 12,
                        }}
                    >
                        <BulkUploadTab key="bulk-upload-tab" />
                    </Grid>
                )}
            </Grid>
        </SCUIContent>
    );
};
